import PropTypes from 'prop-types'
import React from 'react'
import { Modal, ModalBody } from 'reactstrap'
import SpinActionButton from '../Buttons/SpinActionButton'

const ModalDelete = ({ show, onDeleteClick, onCloseClick }) => {
  return (
    <Modal fade={true} isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className="py-3 px-5">
        <div className="mt-2 text-center">
          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>¿Estás seguro?</h4>
            <p className="text-muted mx-4 mb-0">
              ¿Estás seguro de eliminar el registro?
            </p>
          </div>
        </div>
        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button
            type="button"
            className="btn w-sm btn-light"
            data-bs-dismiss="modal"
            onClick={onCloseClick}
          >
            <i className="ri-close-line align-bottom me-1"></i> Cerrar
          </button>
          <SpinActionButton
            onClick={onDeleteClick}
            loading={false}
            text="Si, eliminar"
            color="danger"
            iconClasses="ri-delete-bin-6-line"
          />
        </div>
      </ModalBody>
    </Modal>
  )
}

ModalDelete.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any
}

export default ModalDelete
